<ion-app>
    <!-- Sidemenu stuff -->
    <!-- <ion-split-pane contentId="my-content"> -->
    <!-- <div id="main-content"> -->
        @if (authService.isUserLoggedIn()) {
            <ion-menu menuId="mainMenu" contentId="main-content" color="light">
            <div>
                <ion-header>
                    <ion-header>
                        <ion-toolbar>
                            <ion-grid>
                                <ion-row>
                                    <ion-col class="dealership">
                                        {{vm.dealershipName}}
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col class="welcome">
                                        Welcome Back {{vm.user.firstName}}
                                    </ion-col>
                                </ion-row>
                                <!-- <ion-row>
                                    <ion-col class="role">
                                        ({{vm.user.role}})
                                    </ion-col>
                                </ion-row> -->
                            </ion-grid>
                        </ion-toolbar>
                    </ion-header>
                </ion-header>
            </div>
            
            <ion-content>
                <div scrollY="true" class="sidemenuContainer">
                    <ion-list data-test="sidemenuMenuitems">
                        <!-- @for (p of appPages; track $index) {
                        <ion-menu-toggle auto-hide="false">
                            <ion-item [disabled]="isDisabled()" [routerDirection]="'root'" (click)="onMenuItemClick(p)"
                                      [class.activeMenuitemHighlight]="checkActivePage(p)" [id]="p.title">
                                <ion-icon slot="start" [name]="p.icon"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    {{p.title}}
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>
} -->
                    <!-- Hidden button for Cypress to force close the sidemenu -->
                        <ion-menu-toggle auto-hide="false">
                            <ion-item (click)="onMenuItemClick('Close')" data-test="smCloseButton" style="display: none;">
                                <ion-label>Force Close (Cypress)</ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [routerDirection]="'root'" 
                                    (click)="onMenuItemClick('Dashboard')" data-test="smDashboard"
                                    [class.activeMenuitemHighlight]="checkActivePage('Dashboard')"
                                    [hidden]="hideMenuitem('Dashboard')">
                                <ion-icon slot="start" name="stats-chart"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Dashboard
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [disabled]="isDisabled()" [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Tickets')" data-test="smTickets"
                                    [class.activeMenuitemHighlight]="checkActivePage('Tickets')"
                                    [hidden]="hideMenuitem('Tickets')">
                                <ion-icon slot="start" name="pricetags"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Tickets
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [disabled]="isDisabled()" [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Routes')" data-test="smRoutes"
                                    [class.activeMenuitemHighlight]="checkActivePage('Routes')"
                                    [hidden]="hideMenuitem('Routes')">
                                <ion-icon slot="start" name="color-wand"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Routes
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [disabled]="isDisabled()" [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Navigation')" data-test="smNavigation"
                                    [class.activeMenuitemHighlight]="checkActivePage('Navigation')"
                                    [hidden]="hideMenuitem('Navigation')">
                                <ion-icon slot="start" name="map"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Navigate Route
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [disabled]="isDisabled()" [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Tracker')" data-test="smTracker"
                                    [class.activeMenuitemHighlight]="checkActivePage('Tracker')"
                                    [hidden]="hideMenuitem('Tracker')">
                                <ion-icon slot="start" name="locate"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Tracker
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [disabled]="isDisabled()" [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Marketing')" data-test="smMarketing"
                                    [class.activeMenuitemHighlight]="checkActivePage('Marketing')"
                                    [hidden]="hideMenuitem('Marketing')">
                                <ion-icon slot="start" name="cash"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Marketing
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [disabled]="isDisabled()" [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Reports')" data-test="smReports"
                                    [class.activeMenuitemHighlight]="checkActivePage('Reports')"
                                    [hidden]="hideMenuitem('Reports')">
                                <ion-icon slot="start" name="documents"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Reports
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Settings')" data-test="smSettings"
                                    [class.activeMenuitemHighlight]="checkActivePage('Settings')"
                                    [hidden]="hideMenuitem('Settings')">
                                <ion-icon slot="start" name="construct"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Settings
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Account')" data-test="smAccount"
                                    [class.activeMenuitemHighlight]="checkActivePage('Account')"
                                    [hidden]="hideMenuitem('Account')">
                                <ion-icon slot="start" name="card"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Account
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [routerDirection]="'root'"
                                    (click)="onMenuItemClick('About')" data-test="smAbout"
                                    [class.activeMenuitemHighlight]="checkActivePage('About')"
                                    [hidden]="hideMenuitem('About')">
                                <ion-icon slot="start" name="information-circle"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    About
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Help')" data-test="smHelp"
                                    [class.activeMenuitemHighlight]="checkActivePage('Help')"
                                    [hidden]="hideMenuitem('Help')">
                                <ion-icon slot="start" name="help-circle"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Help
                                </ion-label>
                                @if (vm.unreadMessagesCount > 0) {
                                    <ion-badge slot="end" color="danger" data-test="smHelpBadge">
                                        {{vm.unreadMessagesCount}}
                                    </ion-badge>
                                }
                            </ion-item>
                        </ion-menu-toggle>
                        
                        <ion-menu-toggle auto-hide="false">
                            <ion-item [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Website')" data-test="smWebsite"
                                    [class.activeMenuitemHighlight]="checkActivePage('Website')"
                                    [hidden]="hideMenuitem('Website')">
                                <ion-icon slot="start" name="globe"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Website
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <ion-menu-toggle auto-hide="false">
                            <ion-item [routerDirection]="'root'"
                                    (click)="onMenuItemClick('Logout')" data-test="smLogout"
                                    [class.activeMenuitemHighlight]="checkActivePage('Logout')"
                                    [hidden]="hideMenuitem('Logout')">
                                <ion-icon slot="start" name="close"></ion-icon>
                                <ion-label class="ion-text-wrap">
                                    Logout
                                </ion-label>
                            </ion-item>
                        </ion-menu-toggle>

                        <!-- <ion-menu-toggle auto-hide="false"> -->
                            <!-- <ion-grid class="tagline">
                                <ion-row>
                                    <ion-col>
                                        Because it just makes good business sense.
                                        <hr>
                                        Version: {{vm.version}}
                                    </ion-col>
                                </ion-row>
                            </ion-grid> -->
                        <!-- </ion-menu-toggle> -->

                        <!-- Used by Cypress to close the sidemenu -->
                        <!-- <ion-menu-toggle auto-hide="false">
                            <ion-item class="closeButton" data-test="smCloseSidemenu" href="javascript:;" >
                                <ion-button data-test="smCloseSidemenu">Close sidemenu</ion-button>
                            </ion-item>
                        </ion-menu-toggle> -->
                    </ion-list>
                </div> <!-- scrolly -->
            </ion-content>

             <ion-footer color="tertiary">
                <ion-grid class="tagline">
                    <ion-row>
                        <ion-col>
                            Because it just makes good business sense.<br />
                            Version: {{vm.version}}
                        </ion-col>
                    </ion-row>
                </ion-grid>

                <!-- Used by Cypress to go back to the previous page -->
                <!-- border: none -->
                <!-- <ion-item  style="height:10px; width:10px; "
                        data-test="smGoBack" (click)="onGoBack()" >
                </ion-item> -->

                <!-- <ion-input type="text" data-test="forCypress" 
                    style="height: 1px; width: 1px; border: none; font-size: 1px;">
                </ion-input>    -->
            </ion-footer>

            <!--
                Improving the economics and efficiency of your shuttle department
                just makes good business sense. Not paying one cent until it's
                improved makes more sense.

                Improved csi scores and a revenue generating shuttle department in 30 days
                just makes good business sense. Not paying one cent until it's improved makes
                more sense.

                Improved csi scores and a revenue generating shuttle department in 30 days.

                Improving csi scores and generating revenue by giving away free shuttle
                rides just makes good business sense. Not paying one cent until it's
                improved makes more sense.

                Automating and optimizing your shuttle department so you can have a better 
                relationship with your customers.

                An efficient, revenue generating shuttle department that improves customer 
                relations in 30 days.

                Automating, Optimizing and Improved CSI Scores in 30 Days.ustomer your shuttle 
                department that improves customer relations in 30 days.

                Improved csi scores and a revenue generating shuttle department in 30 days
                or less or just wait longer.  lol.
            -->

        </ion-menu>
    }

        <!-- Router outlet must ALWAYS be present -->
        <ion-router-outlet id="main-content"></ion-router-outlet>
    <!-- </div> -->
    <!-- </ion-split-pane> -->
</ion-app>